module.exports = __webpack_public_path__ + "img/qq_QR.45d68432.png";